import  { useEffect, useMemo, useState } from "react";
import {
  Carousel1,
  Carousel2,
  Carousel3,
  Carousel5,
} from "../../../core/assets";
import { Navbar } from "../../shared/navbar/Navbar";
import { Cons } from "../../../core/assets";
import { RiArrowDownSLine } from "react-icons/ri";
import { motion } from "framer-motion";

export const HomeBanner = () => {
  const initialCarouselData = useMemo(() => [
    { image: Carousel1 },
    { image: Carousel2 },
    { image: Carousel3 },
    { image: Carousel5 },
  ], []
)

  const [carouselData] = useState(initialCarouselData);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    const timeoutId:any = setTimeout(() => {
      setActiveImageIndex(
        (prevIndex) => (prevIndex + 1) % initialCarouselData.length
      );
    }, 8000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [activeImageIndex, initialCarouselData]);

  const backgroundStyle = {
    backgroundImage: `url(${carouselData[activeImageIndex].image})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    overFlow: "hidden",
  };

  return (
    <motion.section
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{
        type: "tween",
        damping: 10,
        stiffness: 100,
        duration: 0.5,
      }}
      className="relative h-[750px] p-5 mt-4 rounded-xl md:h-[95%] w-full  md:rounded-3xl"
      style={backgroundStyle}
      
    >
      <Navbar />
      <motion.div
        className="w-[100%] h-[100%]  flex flex-col justify-center items-center md:rounded-3xl"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // borderRadius: "30px",
          background: "linear-gradient(to bottom, rgba(0,0,0,0), gray)",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: -800 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            type: "spring",
            damping: 10,
            stiffness: 200,
          }}
          className="text-white text-center"
        >
          <div className="text-4xl md:text-7xl text-white ml-12 font-bold flex items-center">
            <div>CONVERSE</div>
            <div>
              <img
                src={Cons}
                className="md:w-[150px] w-[70px]"
                alt="logo"
                style={{  filter: "invert(1)" }}
              />
            </div>{" "}
          </div>
          <div className=" w-full text-start text-lg md:w-[600px] px-10 md:mx-0 md:text-center text-white md:text-xl font-normal">
            As we experience a high volume of visitors to the site for certain
            product launches, we place everyone in a waiting room once the
            product drops so we can provide a fair, first-come-first-served
            order to access the collection.
          </div>
        </motion.div>
      </motion.div>

      <div className="flex justify-end md:mx-10 fixed bottom-10 absolute right-10 animate-bounce border rounded-full p-2 ">
        <RiArrowDownSLine className="text-gray-400 shadow-xl border text-6xl p-3 bg-white rounded-full  hover:bg-gray-200 hover:text-white hover:border-0" />
      </div>
    </motion.section>
  );
};
